import React from 'react';

import type { ConversationMode } from '../../../constants/modes';
import useChatQuotaFirstUseNotice from './useChatQuotaFirstUseNotice';

import './_chat-quota-first-use-notice.scss';

type ChatQuotaFirstUseNoticeProps = {
  hasMessages: boolean;
  mode: ConversationMode;
};

/**
 * Tutor bubble above the greeting that explains the interaction limit before the student spends any.
 * UI only: it is never added to the conversation, and it cannot be closed.
 */
function ChatQuotaFirstUseNotice({ hasMessages, mode }: ChatQuotaFirstUseNoticeProps): JSX.Element | null {
  const notice = useChatQuotaFirstUseNotice({ hasMessages, mode });

  if (!notice) {
    return null;
  }

  return (
    <div className="chat-quota-first-use-notice">
      <p className="chat-quota-first-use-notice__bubble">
        <strong className="chat-quota-first-use-notice__title">{notice.title}</strong> {notice.body}
      </p>
    </div>
  );
}

export default ChatQuotaFirstUseNotice;
